import { InjectionToken } from '@angular/core';
import { SearchService } from '../../../../shared/services/search.service';

export const AutomatedTransfersOnTheRoadSearchService = new InjectionToken<SearchService>('AutomatedTransfersOnTheRoadSearchService');
export const AutomatedTransfersScheduledSearchService = new InjectionToken<SearchService>('AutomatedTransfersScheduledSearchService');
